import axios from "axios";
import { API } from "@/config";

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ns_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

let last402 = 0;
api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Trial/seat soft-lock — open a tailored upgrade prompt (global listener).
    if (err.response?.status === 402) {
      const now = Date.now();
      if (now - last402 > 1200) {
        last402 = now;
        const d = err.response.data?.detail;
        const message = typeof d === "string" ? d : "Upgrade to continue.";
        window.dispatchEvent(new CustomEvent("ns:upgrade", { detail: { message } }));
      }
    }
    return Promise.reject(err);
  }
);

export function apiErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
